import { Component } from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';


@Component({
  selector: 'modal-fleets',
  templateUrl: 'fleets.modal.html',

})
export class FleetsModal{

  private fleets: any = [];
  private filteredFleets: any = [];
  private search: String = '';

  constructor(public navCtrl: NavController,
              public viewCtrl: ViewController,
              public navParams: NavParams) {

    this.fleets = navParams.get('fleets');

  }

  ionViewDidLoad() {

    this.filterfleets();

  }

  filterItems(){

    return this.fleets.filter((company) => {
      return company.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
    });

  }

  dismiss(company) {
    this.viewCtrl.dismiss(company);
  }

  filterfleets(){
    this.filteredFleets = this.filterItems();
  }

  goBack(){
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/modals/fleets/fleets.modal.ts